import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-feedback",
  "use": "icon-feedback-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-feedback\"><path d=\"M853.333 128H170.667C123.733 128 85.333 166.4 85.333 213.333v469.334c0 46.933 38.4 85.333 85.334 85.333h128v128l170.666-128h469.334c46.933 0 85.333-38.4 85.333-85.333V213.333c0-46.933-38.4-85.333-85.333-85.333zm0 554.667H648.533L512 789.333 375.467 682.667H170.667V213.333h682.666v469.334zM341.333 384h341.334v42.667H341.333V384zm0 128h341.334v42.667H341.333V512zm0 128h213.334v42.667H341.333v-42.667z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/feedback.svg
// module id = VQSA
// module chunks = 29